import { AgTechButton, AgTechButtonProps } from '@agtech/web/components/Buttons/AgTechButtons';
import AgTechViewDialog from '@agtech/web/components/Portals/Dialogs/AgTechViewDialog';
import { useCurrentSale } from '@sales/data/sales/SaleDataStore';
import React from 'react'
import SaleLotSellingGrid from '../components/grid/SaleLotSellingGrid';
import { useLotDataGetSaleLotDataQuery } from '@sales/data/lots/LotDataQueries';
import LotUpdateViewDialog from './LotUpdateViewDialog';

const LotSellingViewDialog = () => {
    const dialogQuery = useLotDataGetSaleLotDataQuery();

    return (
        <AgTechViewDialog
            data={{
                query: dialogQuery
            }}
            structure={{
                header: lotData => ({
                    header: `Sell Lots`,
                    detail: "To sell lots for this sale, enter bidder numbers and purchases prices into the grid below",
                    content: () => (
                        <LotUpdateViewDialog.Button />
                    )
                }),
                width: "1200px",
            }}
        >
            {lotData => {
                return (
                    <div className='stretched p-body flex'>
                        <SaleLotSellingGrid lotData={lotData} />
                    </div>
                )
            }}
        </AgTechViewDialog>
    )
}

LotSellingViewDialog.Button = (props: AgTechButtonProps) => {
    let buttonProps: AgTechButtonProps = {
        text: 'Sell Lots',
        icon: 'fas fa-dollar-sign',
        ...props,
        action: e => e.dialogs.openDialog({
            dialog: () => <LotSellingViewDialog />
        })
    };

    return <AgTechButton {...buttonProps} />
}

export default LotSellingViewDialog;